import urls from '../constants/urls'

export const INVITE_REQUESTS_LOAD_FAILED = 'inviteRequests/LOAD_FAILED'
export const INVITE_REQUESTS_LOAD_SUCCESS = 'inviteRequests/LOAD_SUCCESS'
export const LOADING_INVITE_REQUESTS = 'inviteRequests/LOADING'

export const REQUEST_INVITE_FAILED = 'hospitals/REQUEST_INVITE_FAILED'
export const REQUEST_INVITE_SUCCESS = 'hospitals/REQUEST_INVITE_SUCCESS'
export const REQUESTING_INVITE = 'hospitals/REQUESTING_INVITE'

export const REJECT_INVITE_REQUEST_FAILED = 'inviteRequests/REJECT_INVITE_REQUEST_FAILED'
export const REJECT_INVITE_REQUEST_SUCCESS = 'inviteRequests/REJECT_INVITE_REQUEST_SUCCESS'
export const REJECTING_INVITE_REQUEST = 'inviteRequests/REJECTING_INVITE_REQUEST'

const initialState = {
  inviteRequests: [],

  page:  1,
  pages: 1,
  total: 0,

  failedCreating: false,
  failedLoading:  false,
  failedRejecting: false,

  hasLoaded: false,
  hasRejected: false,

  isLoading:  false,
  isCreating: false,
  isRejecting: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_INVITE_REQUESTS:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case INVITE_REQUESTS_LOAD_SUCCESS:
      return {
        ...state,
        inviteRequests: action.payload.data,
        page:           action.payload.headers['x-page'],
        pages:          action.payload.headers['x-pages'],
        total:          action.payload.headers['x-total'],
        isLoading:      false,
        hasLoaded:      true
      }

    case INVITE_REQUESTS_LOAD_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    case REQUESTING_INVITE:
      return {
        ...state,
        failedCreating: false,
        isCreating:     true
      }

    case REQUEST_INVITE_SUCCESS:
      return {
        ...state,
        isCreating: false
      }

    case REQUEST_INVITE_FAILED:
      return {
        ...state,
        failedCreating: true,
        isCreating:     false
      }

    case REJECTING_INVITE_REQUEST:
      return {
        ...state,
        failedRejecting: false,
        isRejecting:     true
      }

    case REJECT_INVITE_REQUEST_SUCCESS:
      return {
        ...state,
        isRejecting: false
      }

    case REJECT_INVITE_REQUEST_FAILED:
      return {
        ...state,
        failedRejecting: true,
        isRejected:     false
      }

    default:
      return state
  }
}

export const loadInviteRequests = (hospital, page, searchTerm) => (dispatch) => {
  return dispatch({
    types:   [LOADING_INVITE_REQUESTS, INVITE_REQUESTS_LOAD_SUCCESS, INVITE_REQUESTS_LOAD_FAILED],
    payload: {
      request: {
        url:    urls.hospitals.invites.requests.index(hospital.id),
        params: { page, search_string: searchTerm }
      }
    }
  })
}

export const requestInvite = (hospitalId) => (dispatch) => {
  return dispatch({
    types:   [REQUESTING_INVITE, REQUEST_INVITE_SUCCESS, REQUEST_INVITE_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.hospitals.invites.requests.create(hospitalId)
      }
    },
    hospitalId
  })
}

export const rejectInviteRequest = (hospitalId, inviteRequestId) => (dispatch) => {
  return dispatch({
    types:   [REJECTING_INVITE_REQUEST, REJECT_INVITE_REQUEST_SUCCESS, REJECT_INVITE_REQUEST_FAILED],
    payload: {
      request: {
        method: 'delete',
        url:    urls.hospitals.invites.requests.destroy(hospitalId, inviteRequestId)
      }
    }
  })
}
